<template>
    <div class="search-container" id="searchBox">
        <div class="search-pill rounded-pill">
            <div class="pill-search">
                <div class="input-group" @click="countySearchTrigger()">
                    <ul class="results-tag-list" id="tagList">
                        <li v-for="city in citiesTags" :key="city.id">
                            <span class="results-tag">
                                <span> {{city.name}} </span>
                                <i class="fad fa-times-circle" @click="deleteCity(city)"></i>
                            </span>
                        </li>
                        <li v-if="citiesTags.length == 0">
                            <input
                              type="search"
                              id="locationSearch"
                              v-model="locationSearch"
                              placeholder="Caută după oraș sau județ..."
                              autocomplete="none"
                              @input="countySearchTrigger()" 
                              @click="countySearchTrigger()"
                            >
                        </li>
                    </ul>
                    <div class="input-icon">
                        <i class="fa fa-chevron-down"></i>
                    </div>
                </div>
                <div class="search-results-box" id="countySearchResultBox">
                    <ul class="search-results-list">
                        <li class="main-result-item" v-for="county in countiesList" :key="`county-${county.id}`">
                            <div class="search-result-line">
                                <div class="result-checkbox">
                                    <input type="radio" class="custom-radio" :value="county" v-model="selectedCounty" :id="`county-${county.id}`" @change="changeCounty()">
                                    <label :for="`county-${county.id}`" class="custom-radio-label">
                                        <span></span>
                                        <p>
                                            {{ county.name }} ({{county.projects_count}} proiecte)
                                        </p>
                                    </label>
                                </div>
                                <button data-toggle="collapse"
                                        :data-target="'#resultListCounty' + county.id"
                                        aria-expanded="true">
                                    <i class="fad fa-chevron-circle-down"></i>
                                </button>
                            </div>
                            <ul :id="'resultListCounty' + county.id"
                                class="collapse show mt-2 results-list-collapse">
                                <li v-for="city in county.cities" :key="`city-${city.id}`">
                                    <div class="general-check">
                                        <input type="checkbox"
                                               :id="`city-${city.id}`"
                                               :value="city"
                                               v-model="selectedCities"
                                               @change="changeCities"
                                               :class="`custom-checkbox checkbox-search-dev cities-county-${county.id}`">
                                        <label :for="`city-${city.id}`" class="custom-checkbox-label">
                                            <span></span>
                                            <p>
                                                {{ city.name }}
                                            </p>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div class="search-result-footer">
                        <button type="button" name="button" v-if="selectedCounty" class="general-btn positive-btn" @click="submitSearch()">
                            <i class="fad fa-search"></i>
                            <span> Cauta </span>
                        </button>
                        <button type="button" name="button" class="general-btn negative-btn" @click="closeResults()">
                            <i class="fad fa-times-circle"></i>
                            <span> Inchide </span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="pill-button">
                <button type="button" :disabled="!selectedCities.length" class="general-btn positive-btn rounded-pill" @click="submitSearch()">
                    <span> Vezi proiecte </span>
                    <i class="fas fa-search"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "HomeSearch",
    props: ['counties'],
    data() {
      return {
        searchIconTriggered: false,
        locationSearch: "",
        projectNameSearch: "",
        selectedCounty: null,
        selectedCities: [],
        projects: []
      }
    },
    computed: {
      countiesList() {
        let vm = this
        if (this.locationSearch.length > 2) {
          return this.counties.filter(county => {
            return county.name.toLowerCase().includes(this.locationSearch.trim().toLowerCase()) ||
              (county.cities && county.cities.find(city => city.name.toLowerCase().includes(vm.locationSearch.trim().toLowerCase())))
          })
        } else {
          return this.counties;
        }
      },
      projectsList() {
        if (this.projectNameSearch.length > 2) {
          return this.projects.filter(project => {
            return (project.name.toLowerCase().includes(this.projectNameSearch.trim().toLowerCase()) ||
              project.code.toLowerCase().includes(this.projectNameSearch.trim().toLowerCase().replace('w','')) ||
              project.county.name.toLowerCase().includes(this.projectNameSearch.trim().toLowerCase()) ||
              project.city.name.toLowerCase().includes(this.projectNameSearch.trim().toLowerCase()) ||
              (project.zone && project.zone.name.toLowerCase().includes(this.projectNameSearch.trim().toLowerCase())) ||
              (project.subzone && project.subzone.name.toLowerCase().includes(this.projectNameSearch.trim().toLowerCase()))
            )
          })
        } else {
          return this.projects;
        }
      },
      citiesTags() {
        return this.selectedCities
      }
    },
    mounted() {
        let vm = this
        setTimeout(function () {
            // First time on homepage
            let countyId = window.getCookie('s_county');
            if (!countyId) {
                vm.setDefaultCityAndCount();
            }
        }, 200)

      this.applyCookie();
    },
    methods: {
        setDefaultCityAndCount() {
            this.selectedCounty = this.counties.find(element => element.id === 1); // Iasi county
            let iasiCity = this.selectedCounty.cities.find(element => element.id === 5); // Iasi city
            this.selectedCities = [];
            this.selectedCities.push(iasiCity);

            window.setCookie('s_county', this.selectedCounty.id, 60);
            window.setCookie('s_cities', JSON.stringify([iasiCity.id]), 60);
        },
      closeResults() {
        let countySearchResultBox = document.getElementById('countySearchResultBox');
        countySearchResultBox.style.display = 'none'
      },

      closeProjectResults() {
        let projectSearchResultBox = document.getElementById('projectsSearchResultBox');
        projectSearchResultBox.style.display = 'none';
        this.resetProjectName();
      },
      countySearchTrigger() {
        let countySearchResultBox = document.getElementById('countySearchResultBox');
        this.searchIconTriggered = true
        countySearchResultBox.style.display = 'block'
        // if (this.locationSearch.length > 0) {
        //   this.searchIconTriggered = true
        //   countySearchResultBox.style.display = 'block'
        // } else {
        //   this.searchIconTriggered = false
        //   countySearchResultBox.style.display = 'none'
        // }
      },
      projectSearchTrigger() {
        let projectSearchResultBox = document.getElementById('projectsSearchResultBox');
        projectSearchResultBox.style.display = 'block'
        // if (this.projectNameSearch.length >= 0) {
        //   projectSearchResultBox.style.display = 'block'
        // } else {
        //   projectSearchResultBox.style.display = 'none'
        // }
      },
      changeCounty() {
        let tagList = document.getElementById('tagList');
        tagList.style.display = 'flex'
        this.selectedCities = [];
        this.selectedCounty.cities.forEach(city => this.selectedCities.push(city));
        // $('.results-list-collapse').collapse('hide')
        // $('#resultListCounty'+this.selectedCounty.id).collapse('show')
        this.projectNameSearch = '';
        this.locationSearch = '';
        window.setCookie('s_county', this.selectedCounty.id, 60);
        if (this.selectedCities.length > 0) {
          let cityIdList = _.map(this.selectedCities,'id');
          window.setCookie('s_cities', JSON.stringify(cityIdList), 60);
        } else {
          window.deleteCookie('s_cities')
        }
        this.fetchProjects()
      },
      changeCities() {
        if (this.selectedCities.length > 0) {
          let lastCity = this.selectedCities.slice(-1).pop()
          // console.log(lastCity);
          if (!this.selectedCounty || this.selectedCounty.id !== lastCity.county_id) {
            this.selectedCounty = this.counties.find(element => element.id === parseInt(lastCity.county_id));
            this.selectedCities = [];
            this.selectedCities.push(lastCity);
          }
        }
        if (this.selectedCounty) {
          window.setCookie('s_county', this.selectedCounty.id, 60);
          if (this.selectedCities.length > 0) {
            let cityIdList = _.map(this.selectedCities,'id');
            window.setCookie('s_cities', JSON.stringify(cityIdList), 60);
          }
        } else {
          window.deleteCookie('s_county');
          window.deleteCookie('s_cities');
        }
        this.fetchProjects()
      },
      applyCookie() {
        let countyId = window.getCookie('s_county');
        if (countyId != '') {
          let county = this.counties.find(element => element.id === parseInt(countyId));
          if (county) {
            this.selectedCounty = county;
            let cities = JSON.parse(window.getCookie('s_cities'));
            if (cities.length > 0) {
              this.selectedCounty.cities.forEach(city => {
                if(cities.includes(city.id)) {
                  this.selectedCities.push(city)
                }
              });
            }
          }
          let tagList = document.getElementById('tagList');
          tagList.style.display = 'flex'
          // $('.results-list-collapse').collapse('hide')
          // $('#resultListCounty'+this.selectedCounty.id).collapse('show')
          this.fetchProjects()
        }
      },
      deleteCity(cityDel) {
        for (let i = 0; i < this.selectedCities.length; i++) {
          if (this.selectedCities[i].id === cityDel.id) {
            this.selectedCities.splice(i, 1);
            if (this.selectedCities.length === 0) {
              this.selectedCounty = null;
            }
          }
        }
        this.changeCities();
      },
      fetchProjects() {
        let vm = this;
        let county = null;
        if (this.selectedCounty) {
          county = this.selectedCounty.id
        }
        let cities = []
        if (this.selectedCities.length > 0) {
          cities =  _.map(this.selectedCities, 'id');
        }
        // this.closeProjectResults();
        window.axios.get('/ajax/search-projects', {
          params: {
            county: county,
            city: cities,
            limit: 100
          }
        })
          .then(function (response) {
            vm.projects = response.data.data.projects;
          })
          .catch(function () {
            // console.log(err);
            // vm.buttonDisable = false;
            // window.showError(err)
          });
      },
      getProjectName(project) {
        let name = project.name+', '+project.county.name+', '+project.city.name;
        if (project.zone) {
          name += ', '+project.zone.name;
        }
        if (project.subzone) {
          name += ', '+project.subzone.name;
        }
        return name;
      },
      submitSearch() {
        if (this.selectedCities.length) {

          let params = {};
          params.orase = [];
            this.selectedCities.forEach(function (city) {
                params.orase.push(city.slug)
            });

          if (this.projectNameSearch && this.projectNameSearch.length > 0) {
            params.q = this.projectNameSearch;
          }

          window.location.href = window.getProjectListRelativeUrl(params);
        }
      },
      resetProjectName() {
        this.projectNameSearch = '';
      },
    },
  }
</script>
